import React, {useRef, useState} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import SeasonList from "./_list";
import SeasonForm from "./_form";

export default function Season() {

    const [collapseForm, setCollapseForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const refForm = useRef();

    const toggleForm = (start, end) => {
        if (start !== undefined && end !== undefined){
            const predefinedItem = {
                endDate : end,
                startDate : start
            }
            setItem(predefinedItem);
        } else {
            setItem(null);
        }
        setEditMode(false);
        setCollapseForm(!collapseForm);
    }

    const beginEdit = (data) => {
        setEditMode(true);
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm &&
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={toggleForm}/>
                            </div>
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm && <SeasonList beginEdit={beginEdit} createNew={toggleForm}/>}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm && <SeasonForm toggleParent={toggleForm} item={item}/>}
                </Col>
            </Row>
        </div>
    );
}
